<template>
  <div id="payment-transactions-page">
    <vx-card
      ref="filterCard"
      title="Filtre"
      class="bank-list-filters mb-8"
      actionButtons
      @refresh="resetFilters"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Ürünler</label>
          <v-select
            :options="productOptions"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            no-data-text="Görüntüleyebileceğiniz sonuç bulunamadı!"
            v-model="productFilter"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Ödeme Sonucu</label>
          <v-select
            :options="payOptions"
            :clearable="false"
            no-data-text="Görüntüleyebileceğiniz sonuç bulunamadı!"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="payFilter"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Ödeme Aracı</label>
          <v-select
            :options="paymethodOptions"
            :clearable="false"
            no-data-text="Görüntüleyebileceğiniz sonuç bulunamadı!"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="paymethodFilter"
            class="mb-4 md:mb-0"
          />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ (currentPage - 1) * pageSize + 1 }}
                -
                {{ Math.min(currentPage * pageSize, totalCount) }}
                / {{ totalCount }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="changePageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="debouncedSearch"
          :placeholder="$t('GridSearch')"
        />
        <vs-button class="mb-4 md:mb-0" @click="activePrompt = true"
          >Tabloyu Dışarı Aktar</vs-button
        >
      </div>

      <ag-grid-vue
        ref="agGridTable"
        id="paymentTransactionGrid"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table vs-con-loading__container"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="gridData"
        colResizeDefault="shift"
        :animateRows="true"
        rowSelection="single"
        :pagination="false"
        @grid-ready="onGridReady"
        @sort-changed="onSortChanged"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <div class="flex justify-between items-center mt-4">
        <span class="text-sm text-grey">
          Toplam {{ totalCount }} kayıt, Sayfa {{ currentPage }} / {{ totalPages }}
        </span>
        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
      </div>
    </div>

    <vs-popup
      v-show="syncBankDetailPopup && popupDesc"
      :title="popupTitle"
      fullscreen
      :active.sync="syncBankDetailPopup"
    >
      <div id="invoice-container">
        <div class="vx-row leading-loose p-base">
          <div class="vx-col w-full md:w-1/2 mt-base">
            <img src="@/assets/images/logo/logo.png" alt="FSMVU" width="200" />
          </div>
          <div class="vx-col w-full md:w-1/2 text-right">
            <h1>Hizmet</h1>
            <div class="invoice__invoice-detail mt-6">
              <h6>HİZMET NO.</h6>
              <p>#{{ popupDesc.Invoice.InvoiceKey }}</p>
              <h6 class="mt-4">OLUŞTURMA TARİHİ</h6>
              <p>{{ popupDesc.Invoice.CreateDate | date_tr }}</p>
            </div>
          </div>
          <div class="vx-col w-full md:w-1/2 mt-12">
            <h5>MÜŞTERİ</h5>
            <div class="invoice__recipient-info my-4">
              <p>{{ popupDesc.UserInfo.FullName }}</p>
              <p>{{ popupDesc.UserInfo.IdentityNumber }}</p>
            </div>
            <div class="invoice__recipient-contact">
              <p class="flex items-center">
                <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                <span class="ml-2">{{ popupDesc.UserInfo.Email }}</span>
              </p>
              <p class="flex items-center">
                <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                <span class="ml-2">{{ popupDesc.UserInfo.Phone }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="p-base">
          <vs-table hoverFlat :data="popupDesc">
            <template slot="thead">
              <vs-th>Ürün Adı</vs-th>
              <vs-th>Ürün Fiyatı</vs-th>
            </template>
            <vs-tr>
              <vs-td>
                {{ popupDesc.Invoice.SettingGroup.ProductTitle }}
                <span v-if="popupDesc.Invoice.SettingGroup.ProductDesc"
                  >({{ popupDesc.Invoice.SettingGroup.ProductDesc }})</span
                >
              </vs-td>
              <vs-td>{{ popupDesc.Invoice.SettingGroup.Price | currency }}</vs-td>
            </vs-tr>
          </vs-table>

          <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="popupDesc">
            <vs-tr>
              <vs-th>ÜRÜN TOPLAMI</vs-th>
              <vs-td>{{ popupDesc.Invoice.InvoicePrice | currency }}</vs-td>
            </vs-tr>
            <vs-tr
              v-for="(dc, index) in popupDesc.Invoice.DiscountRules"
              :key="index"
            >
              <vs-th>({{ dc.DiscountDesc }}%)</vs-th>
              <vs-td>-{{ dc.DiscountPrice | currency }}</vs-td>
            </vs-tr>
            <vs-tr>
              <th>ÖDENMESİ GEREKEN TUTAR</th>
              <td>{{ popupDesc.Simulate.Amount | currency }}</td>
            </vs-tr>
          </vs-table>

          <vs-table
            hoverFlat
            :data="popupDesc.Invoice.Transactions"
            class="mt-5"
          >
            <template slot="thead">
              <vs-th>İŞLEM TARİHİ</vs-th>
              <vs-th>BANKA CEVABI</vs-th>
              <vs-th>KART BİLGİLERİ</vs-th>
              <vs-th>ÖDEME TUTARI</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                :state="data[index].TransactionState == 0 ? 'success' : ''"
                v-for="(tr, index) in data"
                :key="index"
              >
                <vs-td :data="data[index].ModifiedDate">{{
                  data[index].ModifiedDate | date_tr
                }}</vs-td>
                <vs-td :data="data[index].Response">{{
                  data[index].Response
                }}</vs-td>
                <vs-td :data="data[index].Message">{{
                  data[index].Message
                }}</vs-td>
                <vs-td :data="data[index].PayPrice">{{
                  data[index].PayPrice | currency
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vs-popup>

    <vs-prompt
      title="Tablonuzu Dışarı Aktarın"
      class="export-options"
      @cancle="cancelExport"
      @accept="exportToExcel"
      accept-text="Aktar"
      cancel-text="Vazgeç"
      @close="cancelExport"
      :active.sync="activePrompt"
      :is-valid="!exporting"
    >
      <div v-if="!exporting">
        <vs-input
          v-model="fileName"
          placeholder="Dosya adını girin..."
          class="w-full"
        />
        <v-select v-model="selectedFormat" :options="formats" class="my-4" />
        <div class="flex">
          <span class="mr-4">Hücre Genişliği Otomatik:</span>
          <vs-switch v-model="cellAutoWidth">Hücre Genişliği Otomatik</vs-switch>
        </div>
      </div>
      <div v-else class="text-center" style="padding: 32px 0;">
        <vs-progress indeterminate color="primary"></vs-progress>
        <p style="font-size: 16px; font-weight: 600; margin-top: 16px;">Excel dosyanız hazırlanıyor...</p>
        <p style="font-size: 13px; color: #999; margin-top: 8px;">Lütfen bekleyiniz, bu işlem birkaç saniye sürebilir.</p>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

import InvoiceApi from "@/api/invoice";
import StaffApi from "@/api/staff";

import CellRendererDate from "./cell-renderer/CellRendererDate.vue";
import CellTransactionState from "./cell-renderer/CellTransactionState.vue";

import moment from "moment";

let searchTimeout = null;

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererDate,
    CellTransactionState,
  },
  data() {
    return {
      // Export
      fileName: "",
      activePrompt: false,
      cellAutoWidth: true,
      formats: ["xlsx", "csv", "txt"],
      selectedFormat: "xlsx",
      headerTitle: [
        "Hizmet Numarası",
        "Adı Soyadı",
        "E-Posta",
        "Telefon",
        "Ürün Adı",
        "Fiyatı",
        "Ödeme Durumu",
        "Oluşturma Tarihi",
      ],
      headerVal: [
        "Invoice.InvoiceKey",
        "UserInfo.FullName",
        "UserInfo.Email",
        "UserInfo.Phone",
        "Invoice.SettingGroup.ProductTitle",
        "Invoice.InvoicePrice",
        "IsPaymentRequired.Need",
        "Invoice.CreateDate",
      ],

      // Filters
      productFilter: { label: "-tüm ürünler-", value: "" },
      productOptions: [],
      payFilter: { label: "-tüm sonuçlar-", value: "" },
      payOptions: [
        { label: "-tüm sonuçlar-", value: "" },
        { label: "Başarılı Ödemeler", value: "0" },
        { label: "Başarısız Ödemeler", value: "1" },
      ],
      paymethodFilter: { label: "-tüm sonuçlar-", value: "" },
      paymethodOptions: [
        { label: "-tüm sonuçlar-", value: "" },
        { label: "Vakıfbank İktisadi", value: "1" },
        { label: "Teb İktisadi", value: "2" },
        { label: "Denizbank İktisadi", value: "3" },
      ],

      // Server-side state
      searchQuery: "",
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      sortField: "createdate",
      sortDirection: "desc",
      gridData: [],
      isLoading: false,
      exporting: false,
      exportAbortController: null,

      // Detail popup
      syncBankDetailPopup: false,
      popupTitleData: "",
      popupDescData: {
        Simulate: {},
        UserInfo: {},
        Invoice: {
          SettingGroup: {},
          Transactions: {},
        },
        IsPaymentRequired: {},
        PaidAmount: 0,
      },

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "#SettingGroupId",
          field: "Invoice.SettingGroup.InvoiceSettingGroupID",
          hide: true,
        },
        {
          headerName: "#InvoiceId",
          field: "Invoice.InvoiceID",
          hide: true,
        },
        {
          headerName: this.$t("Table.Transactions.InvoiceKey"),
          field: "Invoice.InvoiceKey",
          maxWidth: 130,
        },
        {
          headerName: this.$t("Table.Transactions.UserName"),
          field: "UserInfo.FullName",
          minWidth: 240,
        },
        {
          headerName: this.$t("Table.Transactions.UserEmail"),
          field: "UserInfo.Email",
        },
        {
          headerName: this.$t("Table.Transactions.UserPhone"),
          field: "UserInfo.Phone",
          maxWidth: 150,
        },
        {
          headerName: this.$t("Table.Transactions.ProductTitle"),
          field: "Invoice.SettingGroup.ProductTitle",
        },
        {
          headerName: this.$t("Table.Transactions.ProductPrice"),
          field: "Invoice.InvoicePrice",
          valueGetter: this.currencyFormat,
          maxWidth: 130,
        },
        {
          headerName: this.$t("Table.Transactions.State"),
          field: "IsPaymentRequired.Need",
          autoHeight: true,
          sortable: false,
          cellRendererFramework: "CellTransactionState",
        },
        {
          headerName: this.$t("Table.Transactions.Date"),
          field: "Invoice.CreateDate",
          sort: "desc",
          valueGetter: function (params) {
            return moment(String(params.data.Invoice.CreateDate)).format(
              "DD.MM.YYYY HH:mm"
            );
          },
        },
      ],
      components: {
        CellRendererDate,
        CellTransactionState,
      },
    };
  },
  watch: {
    productFilter() {
      this.currentPage = 1;
      this.fetchData();
    },
    payFilter() {
      this.currentPage = 1;
      this.fetchData();
    },
    paymethodFilter() {
      this.currentPage = 1;
      this.fetchData();
    },
    currentPage() {
      this.fetchData();
    },
  },
  computed: {
    popupTitle() {
      return this.popupTitleData;
    },
    popupDesc() {
      return this.popupDescData;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize));
    },
  },
  methods: {
    currencyFormat(params) {
      return this.$options.filters.currency(params.data.Invoice.InvoicePrice);
    },
    changePageSize(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchData();
    },
    debouncedSearch() {
      if (searchTimeout) clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchData();
      }, 400);
    },
    resetFilters() {
      this.$refs.filterCard.removeRefreshAnimation();
      this.productFilter = { label: "-tüm ürünler-", value: "" };
      this.payFilter = { label: "-tüm sonuçlar-", value: "" };
      this.paymethodFilter = { label: "-tüm sonuçlar-", value: "" };
      this.searchQuery = "";
      this.currentPage = 1;
      this.fetchData();
    },
    async fetchData() {
      this.isLoading = true;
      this.$vs.loading({
        color: "#000",
        container: "#paymentTransactionGrid",
        scale: 0.45,
      });

      const body = {
        page: this.currentPage,
        pageSize: this.pageSize,
        sortField: this.sortField,
        sortDirection: this.sortDirection,
        searchText: this.searchQuery || null,
        productId: this.productFilter.value || null,
        paymentState: this.payFilter.value !== "" ? parseInt(this.payFilter.value) : null,
        paymethodId: this.paymethodFilter.value || null,
      };

      try {
        let response = await InvoiceApi.getPaymentTransactions(body, this);
        if (response.data && response.data.success) {
          this.gridData = response.data.data;
          this.totalCount = response.data.totalCount;
        }
      } catch (e) {
        console.error("Payment transactions fetch error:", e);
      }

      setTimeout(() => {
        this.$vs.loading.close("#paymentTransactionGrid .con-vs-loading");
      }, 100);
      this.isLoading = false;
    },
    onSelectionChanged(event) {
      if (event.node.data) {
        this.popupTitleData =
          event.node.data.Invoice.InvoiceKey +
          " - " +
          event.node.data.Invoice.SettingGroup.ProductTitle;
        this.popupDescData = event.node.data;
        this.syncBankDetailPopup = true;
      }
    },
    onSortChanged() {
      if (!this.gridApi) return;
      const sortModel = this.gridApi.getSortModel();
      if (sortModel && sortModel.length > 0) {
        const col = sortModel[0];
        // Map ag-grid field to backend sortField
        const fieldMap = {
          "Invoice.InvoiceKey": "invoicekey",
          "UserInfo.FullName": "fullname",
          "Invoice.InvoicePrice": "invoiceprice",
          "Invoice.CreateDate": "createdate",
        };
        this.sortField = fieldMap[col.colId] || col.colId;
        this.sortDirection = col.sort; // "asc" or "desc"
      } else {
        this.sortField = "";
        this.sortDirection = "desc";
      }
      this.currentPage = 1;
      this.fetchData();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      window.onresize = () => {
        this.gridApi.sizeColumnsToFit();
      };
    },
    getGridLocaleText(key, defaultValue) {
      var gridKey = "Grid_" + key;
      var value = this.$t(gridKey);
      return value === gridKey ? defaultValue : value;
    },
    async exportToExcel() {
      this.exporting = true;
      const abortController = new AbortController();
      this.exportAbortController = abortController;

      // vs-prompt @accept otomatik kapanıyor, biz tekrar açıyoruz
      await this.$nextTick();
      this.activePrompt = true;

      const body = {
        page: 1,
        pageSize: 999999,
        sortField: this.sortField,
        sortDirection: this.sortDirection,
        searchText: this.searchQuery || null,
        productId: this.productFilter.value || null,
        paymentState: this.payFilter.value !== "" ? parseInt(this.payFilter.value) : null,
        paymethodId: this.paymethodFilter.value || null,
      };

      try {
        const endpoint = InvoiceApi.exportPaymentTransactions();
        const url = process.env.VUE_APP_BASE_URL + this.$i18n.locale + endpoint;
        const tokenKey = process.env.VUE_APP_COOKIE_AUTH || "Union.AuthCookieJwt";
        const token = $cookies.get(tokenKey);
        const axios = require("axios").default;
        const exportHttp = axios.create();
        const response = await exportHttp.post(url, body, {
          responseType: "blob",
          headers: { Authorization: `Bearer ${token}` },
          timeout: 120000,
          signal: abortController.signal,
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = (this.fileName || "odeme_islemleri") + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (e) {
        if (e.name !== "CanceledError" && e.code !== "ERR_CANCELED") {
          console.error("Export error:", e);
        }
      } finally {
        this.exporting = false;
        this.exportAbortController = null;
        this.clearFields();
        this.activePrompt = false;
      }
    },
    cancelExport() {
      if (this.exportAbortController) {
        this.exportAbortController.abort();
      }
      this.exporting = false;
      this.exportAbortController = null;
      this.clearFields();
      this.activePrompt = false;
    },
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },
  },
  beforeMount() {
    this.gridOptions.localeTextFunc = this.getGridLocaleText;
    this.gridOptions.onRowDoubleClicked = this.onSelectionChanged;
  },
  async mounted() {
    this.$emit("setAppClasses", "invoice-page");
    this.gridApi = this.gridOptions.api;

    // Load products for filter
    let response = await StaffApi.getMyProducts(this);
    if (response && response.data && !response.data.error) {
      this.productOptions = response.data.model.map((m) =>
        (({ ProductTitle, InvoiceSettingGroupID }) => ({
          label: ProductTitle,
          value: InvoiceSettingGroupID,
        }))(m)
      );
      var filterArray = [this.productFilter];
      this.productOptions = filterArray.concat(this.productOptions);
    }

    // Load first page
    await this.fetchData();
  },
  beforeDestroy() {
    [...document.getElementsByClassName("con-vs-popup")].map(
      (n) => n && n.remove()
    );
    this.$store.commit("TOGGLE_CONTENT_OVERLAY", false);
  },
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }
    #content-area {
      margin: 0 !important;
    }
    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}
</style>
